import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";

import { ConfirmJobChargesPopupStyle } from "./style";

function ConfirmRefreshJobChargesPopup(props) {
  const classes = ConfirmJobChargesPopupStyle();
  const [scroll] = useState("body");
  return (
    <div className={classes.ConfirmWrapper}>
      <Dialog
        open={props.open}
        scroll={scroll}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: "left" }}>Refresh Recommended</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ textAlign: "left" }}>
            This list of impacted items was generated on <b>{props.createdDate}</b>. New jobs and invoices may have been added since then.
            <br /><br />
            Please refresh to ensure you are reviewing the most up-to-date data.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.handleConfirm}
            color="primary"
            className="primary-btn gray-border-btn"
          >
            OK
          </Button>
          <Button
            onClick={props.handleClose}
            color="primary"
            className="orange-btn primary-btn"
          >
            PROCEED
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default ConfirmRefreshJobChargesPopup;
